import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { TeacherSubmissionDetailPage } from '@/features/teacherSubmissions/pages/TeacherSubmissionDetailPage';

export const Route = createFileRoute('/_auth/settings/teacher-submissions/$teacherId')({
  parseParams: ({ teacherId }) => {
    const parsedId = Number(teacherId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { teacherId: parsedId };
  },
  component: function TeacherSubmissionDetailRoute() {
    const { teacherId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Teacher Submission">
        <Suspense fallback={<PageLoader />}>
          <TeacherSubmissionDetailPage teacherId={teacherId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
